import { createSlice, } from "@reduxjs/toolkit";
import {fetchPosts, createPost,updatePost, deletePost, likedPost} from './postthunk'
const initialState = {
       prevPosts:[],
       isLoading: false,
       currentId :0
    }

 export const postSlice = createSlice({
    name: 'posts',
    initialState,
    reducers:{
       setCurrentId: (state, action) => {

      state.currentId = action.payload

       },
    },
    extraReducers:{
     [fetchPosts.rejected]: (state) =>{
   state.isLoading = true
      },
       [fetchPosts.pending]: (state) =>{
   state.isLoading = true
      },
      [fetchPosts.fulfilled]: (state, action) =>{          
   state.isLoading = false
   state.prevPosts = action.payload
      },
      [createPost.fulfilled] : (state, action) => {
         state.prevPosts = [...state.prevPosts, action.payload]
      },
       [updatePost.rejected] : (state) => {
    },
      [updatePost.pending] : (state) => {
    },
      [updatePost.fulfilled] : (state, action) => {
             state.prevPosts= state.prevPosts.map(post =>post._id===action.payload._id?action.payload:post)
             alert('post updated') 
          },
      [deletePost.fulfilled] : (state, action) => {
           state.prevPosts = state.prevPosts.filter(post => post._id !== action.payload._id)
       
    },
    [likedPost.fulfilled] : (state, action) => {
       state.prevPosts= state.prevPosts.map(post =>post._id===action.payload._id?action.payload:post)
    },
     [likedPost.pending] : (state, action) => {
      
     },
     [likedPost.rejected] : (state, action) => {
          alert('liking post rejected, you must be logged in in order to like post' )
     }
    },
   
})

 export const {setCurrentId} = postSlice.actions

export default postSlice.reducer
